import BmiCalculator from './components/BmiCalculator'

import {GlobalStyle} from './styledComponents'

const App = () => (
  <>
    <GlobalStyle />
    <BmiCalculator />
  </>
)

export default App
